import * as ko from 'knockout';
import entityBase from 'entityBase';
import { contact } from 'entitiesE';
import { place } from 'organized';
export class place_contact extends entityBase {
    contact_sequence: KnockoutObservable<number>;
    place_id        : KnockoutObservable<string>;
    role_type       : KnockoutObservable<string>;
    contact         : KnockoutObservable<contact>;
    place           : KnockoutObservable<place>;

    constructor(item: any){
        super();
        this.contact_sequence = ko.observable(item.contact_sequence);
        this.place_id         = ko.observable(item.place_id).extend({ maxLength: 32 });
        this.role_type        = ko.observable(item.role_type).extend({ maxLength: 128 });
        this.contact          = ko.observable();
        this.place            = ko.observable();
        if(item.contact) {
            this.contact(new contact(item.contact));
        }
        if(item.place) {
            this.place(new place(item.place));
        }
    }
}


